import type {
  ServiceGetAllResponse,
  ServiceQueryOptionType
} from '@/types/service'

import { api, handleAxiosError } from '@/lib/axios'

import type { GapoktanResponseData } from './types'

const LIST_GAPOKTAN_QUERY_KEY = (key?: string | Record<string, any>) =>
  ['list_gapoktan', key] as const

const getAll = (
  params: Partial<{
    perPage?: number
    per_page?: number
    page: number
    search: string
    province_code: string
    city_code: string
    district_code: string
    village_code: string
    status?: 'active' | 'inactive'
  }>
): ServiceQueryOptionType<ServiceGetAllResponse<GapoktanResponseData[]>> => ({
  queryKey: LIST_GAPOKTAN_QUERY_KEY(params),
  queryFn: async () => {
    try {
      const q = {
        per_page: params.per_page || params.perPage || 10,
        page: params.page || 1,
        search: (params.search ?? '').length > 2 ? params.search : undefined,
        province_code:
          (params.province_code ?? '').length > 0
            ? params.province_code
            : undefined,
        city_code:
          (params.city_code ?? '').length > 0 ? params.city_code : undefined,
        district_code:
          (params.district_code ?? '').length > 0
            ? params.district_code
            : undefined,
        village_code:
          (params.village_code ?? '').length > 0
            ? params.village_code
            : undefined,
        status: !params.status
          ? undefined
          : params.status === 'active'
            ? 'Aktif'
            : 'Tidak Aktif'
      }

      const response = await api.get<
        ServiceGetAllResponse<GapoktanResponseData[]>
      >('/report/extension-personnel-main/list-gapoktan', { params: q })

      return response.data
    } catch (error) {
      throw handleAxiosError(error)
    }
  }
})

export const listGapoktan = {
  queryKey: LIST_GAPOKTAN_QUERY_KEY,
  getAll
}
